import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./HomeNavbar.css";
import logo from "../assets/Black Logo.png";

const HomeNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="home-navbar">
      <div className="home-nav-container">
        <div className="home-nav-logo">
          <Link to="/" aria-label="Home page" onClick={closeMenu}>
            <img
              src={logo}
              alt="Dilan Munasingha Photography"
              className="home-logo-image"
            />
          </Link>
        </div>

        {/* Menu List - Different style for home page */}
        <ul className={`home-nav-menu ${isMenuOpen ? "active" : ""}`}>
          <li className="home-nav-item">
            <Link to="/" className="home-nav-link" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li className="home-nav-item">
            <Link to="/portfolio" className="home-nav-link" onClick={closeMenu}>
              Portfolio
            </Link>
          </li>
          <li className="home-nav-item">
            <Link to="/works" className="home-nav-link" onClick={closeMenu}>
              Our Work
            </Link>
          </li>
          <li className="home-nav-item">
            <Link to="/about" className="home-nav-link" onClick={closeMenu}>
              About Me
            </Link>
          </li>

          <li className="home-nav-item">
            <Link to="/contact" className="home-nav-link" onClick={closeMenu}>
              Contact
            </Link>
          </li>
        </ul>

        {/* Mobile Hamburger Menu */}
        <div
          className={`home-hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span className="home-bar"></span>
          <span className="home-bar"></span>
          <span className="home-bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default HomeNavbar;
